import {UPDATE_GEN_ANSWER, UPDATE_GEN_RESPONSE, UPDATE_OS_CONTACTS} from '../action/types'
import update from 'immutability-helper';

const initialState = {
    surveyAnswersForm: {},
    surveyResponses: {},
    osContactForm: [] //Ownership Survey
}

export default function genericSurveyReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_GEN_ANSWER:
            let newMap;
            let survey = state.surveyAnswersForm[action.payload.surveyCode];
            if(survey){
                newMap = [...survey];
            }else{
                newMap = [];
            }
            let questionIndex = newMap.findIndex(q => parseInt(q.questionId) === parseInt(action.payload.questionId));
            if (questionIndex >= 0) {
                newMap[questionIndex] = { ...newMap[questionIndex], answer: action.payload.answer };
            } else {
                newMap.push({ questionId: parseInt(action.payload.questionId), answer: action.payload.answer });
            }
            if(action.payload.childRemoved && action.payload.childRemoved.length > 0){
                newMap = newMap.filter((map)=>{return !action.payload.childRemoved.includes(map.questionId)});
            }
            return update(state, {
                surveyAnswersForm: {[action.payload.surveyCode]: { $set: newMap }}
            })
        case UPDATE_GEN_RESPONSE:
            return update(state, {
                surveyResponses: {[action.payload.surveyCode]: { $set: action.payload.surveyResponse }},
                surveyAnswersForm: {[action.payload.surveyCode]: { $set: action.payload.surveyResponse.surveyAnswers}},
                osContactForm: action.payload.surveyResponse.ownershipContact ? {$set: action.payload.surveyResponse.ownershipContact} : {$set: []}
            })
        case UPDATE_OS_CONTACTS: 
            let contacts = state.osContactForm;
            let contactIndex = contacts.findIndex(contact=> contact.id === action.payload.id);
            if(contactIndex >= 0){
                if (action.payload.field) 
                    contacts[contactIndex] = { ...contacts[contactIndex], [action.payload.field]: action.payload.value };
                else if (action.payload.fieldNamesToClear) {
                    let tempObj = {};
                    action.payload.fieldNamesToClear.forEach((item) => (tempObj[item] = ""));
                    contacts[contactIndex] = { ...contacts[contactIndex], ...tempObj };
                }
            }else{
                if(action.payload.field)
                    contacts.push({...action.payload.contact, [action.payload.field]: action.payload.value});
                else
                    contacts.push({...action.payload.contact}) // Newly Added
            }
            return update(state, {
                osContactForm: {$set: contacts}
            })
        default:
            return state
    }
}